export type Country = { code: string; name: string; dial: string; flag: string };

export const COUNTRIES: Country[] = [
  { code: "IN", name: "India", dial: "+91", flag: "🇮🇳" },
  { code: "TR", name: "Turkey", dial: "+90", flag: "🇹🇷" },
  { code: "CN", name: "China", dial: "+86", flag: "🇨🇳" },
  { code: "ID", name: "Indonesia", dial: "+62", flag: "🇮🇩" },
  { code: "AE", name: "United Arab Emirates", dial: "+971", flag: "🇦🇪" },
  { code: "SA", name: "Saudi Arabia", dial: "+966", flag: "🇸🇦" },
  { code: "US", name: "United States", dial: "+1", flag: "🇺🇸" },
  { code: "GB", name: "United Kingdom", dial: "+44", flag: "🇬🇧" },
  { code: "DE", name: "Germany", dial: "+49", flag: "🇩🇪" },
  { code: "FR", name: "France", dial: "+33", flag: "🇫🇷" },
  { code: "IT", name: "Italy", dial: "+39", flag: "🇮🇹" },
  { code: "ES", name: "Spain", dial: "+34", flag: "🇪🇸" },
  { code: "NL", name: "Netherlands", dial: "+31", flag: "🇳🇱" },
  { code: "PL", name: "Poland", dial: "+48", flag: "🇵🇱" },
  { code: "UA", name: "Ukraine", dial: "+380", flag: "🇺🇦" },
  { code: "KZ", name: "Kazakhstan", dial: "+7", flag: "🇰🇿" },
  { code: "RU", name: "Russia", dial: "+7", flag: "🇷🇺" },
  { code: "GE", name: "Georgia", dial: "+995", flag: "🇬🇪" },
  { code: "AZ", name: "Azerbaijan", dial: "+994", flag: "🇦🇿" },
  { code: "AM", name: "Armenia", dial: "+374", flag: "🇦🇲" },
  { code: "UZ", name: "Uzbekistan", dial: "+998", flag: "🇺🇿" },
  { code: "PK", name: "Pakistan", dial: "+92", flag: "🇵🇰" },
  { code: "BD", name: "Bangladesh", dial: "+880", flag: "🇧🇩" },
  { code: "VN", name: "Vietnam", dial: "+84", flag: "🇻🇳" },
  { code: "TH", name: "Thailand", dial: "+66", flag: "🇹🇭" },
  { code: "MY", name: "Malaysia", dial: "+60", flag: "🇲🇾" },
  { code: "SG", name: "Singapore", dial: "+65", flag: "🇸🇬" },
  { code: "PH", name: "Philippines", dial: "+63", flag: "🇵🇭" },
  { code: "JP", name: "Japan", dial: "+81", flag: "🇯🇵" },
  { code: "KR", name: "South Korea", dial: "+82", flag: "🇰🇷" },
  { code: "HK", name: "Hong Kong", dial: "+852", flag: "🇭🇰" },
  { code: "TW", name: "Taiwan", dial: "+886", flag: "🇹🇼" },
  { code: "AU", name: "Australia", dial: "+61", flag: "🇦🇺" },
  { code: "NZ", name: "New Zealand", dial: "+64", flag: "🇳🇿" },
  { code: "CA", name: "Canada", dial: "+1", flag: "🇨🇦" },
  { code: "MX", name: "Mexico", dial: "+52", flag: "🇲🇽" },
  { code: "BR", name: "Brazil", dial: "+55", flag: "🇧🇷" },
  { code: "AR", name: "Argentina", dial: "+54", flag: "🇦🇷" },
  { code: "CL", name: "Chile", dial: "+56", flag: "🇨🇱" },
  { code: "CO", name: "Colombia", dial: "+57", flag: "🇨🇴" },
  { code: "ZA", name: "South Africa", dial: "+27", flag: "🇿🇦" },
  { code: "EG", name: "Egypt", dial: "+20", flag: "🇪🇬" },
  { code: "NG", name: "Nigeria", dial: "+234", flag: "🇳🇬" },
  { code: "KE", name: "Kenya", dial: "+254", flag: "🇰🇪" },
  { code: "MA", name: "Morocco", dial: "+212", flag: "🇲🇦" },
  { code: "IL", name: "Israel", dial: "+972", flag: "🇮🇱" },
  { code: "QA", name: "Qatar", dial: "+974", flag: "🇶🇦" },
  { code: "KW", name: "Kuwait", dial: "+965", flag: "🇰🇼" },
  { code: "BH", name: "Bahrain", dial: "+973", flag: "🇧🇭" },
  { code: "OM", name: "Oman", dial: "+968", flag: "🇴🇲" },
  { code: "IR", name: "Iran", dial: "+98", flag: "🇮🇷" },
  { code: "IQ", name: "Iraq", dial: "+964", flag: "🇮🇶" },
  { code: "CH", name: "Switzerland", dial: "+41", flag: "🇨🇭" },
  { code: "AT", name: "Austria", dial: "+43", flag: "🇦🇹" },
  { code: "BE", name: "Belgium", dial: "+32", flag: "🇧🇪" },
  { code: "SE", name: "Sweden", dial: "+46", flag: "🇸🇪" },
  { code: "NO", name: "Norway", dial: "+47", flag: "🇳🇴" },
  { code: "DK", name: "Denmark", dial: "+45", flag: "🇩🇰" },
  { code: "FI", name: "Finland", dial: "+358", flag: "🇫🇮" },
  { code: "IE", name: "Ireland", dial: "+353", flag: "🇮🇪" },
  { code: "PT", name: "Portugal", dial: "+351", flag: "🇵🇹" },
  { code: "GR", name: "Greece", dial: "+30", flag: "🇬🇷" },
  { code: "CZ", name: "Czechia", dial: "+420", flag: "🇨🇿" },
  { code: "RO", name: "Romania", dial: "+40", flag: "🇷🇴" },
  { code: "HU", name: "Hungary", dial: "+36", flag: "🇭🇺" },
  { code: "BG", name: "Bulgaria", dial: "+359", flag: "🇧🇬" },
];

/** Allowed national number lengths (digits, without country code) per country. */
export const PHONE_LEN: Record<string, [number, number]> = {
  IN: [10, 10], TR: [10, 10], CN: [11, 11], ID: [9, 12], AE: [9, 9], SA: [9, 9],
  US: [10, 10], GB: [10, 10], DE: [10, 11], FR: [9, 9], IT: [9, 10], ES: [9, 9],
  NL: [9, 9], PL: [9, 9], UA: [9, 9], KZ: [10, 10], RU: [10, 10], GE: [9, 9],
  AZ: [9, 9], AM: [8, 8], UZ: [9, 9], PK: [10, 10], BD: [10, 10], VN: [9, 9],
  TH: [9, 9], MY: [9, 10], SG: [8, 8], PH: [10, 10], JP: [10, 10], KR: [9, 10],
  HK: [8, 8], TW: [9, 9], AU: [9, 9], NZ: [8, 10], CA: [10, 10], MX: [10, 10],
  BR: [10, 11], AR: [10, 10], CL: [9, 9], CO: [10, 10], ZA: [9, 9], EG: [10, 10],
  NG: [10, 10], KE: [9, 9], MA: [9, 9], IL: [9, 9], QA: [8, 8], KW: [8, 8],
  BH: [8, 8], OM: [8, 8], IR: [10, 10], IQ: [10, 10], CH: [9, 9], AT: [10, 13],
  BE: [9, 9], SE: [7, 9], NO: [8, 8], DK: [8, 8], FI: [9, 10], IE: [9, 9],
  PT: [9, 9], GR: [10, 10], CZ: [9, 9], RO: [9, 9], HU: [9, 9], BG: [8, 9],
};

export const lenRange = (code: string): [number, number] => PHONE_LEN[code] ?? [7, 15];

export function lengthMessage(code: string) {
  const [min, max] = lenRange(code);
  return min === max
    ? `Enter a valid phone number (${min} digits).`
    : `Enter a valid phone number (${min}–${max} digits).`;
}

export function formatDigits(v: string, max = 15) {
  const d = v.replace(/\D/g, "").slice(0, max);
  return d.replace(/(\d{3})(?=\d)/g, "$1 ").trim();
}
